import { Dialog, DialogContent } from "@tellescope/ui";
import type { CalendarEvent } from "@tellescope/types-models";
import { AppointmentDetailsContent } from "./AppointmentDetailsContent";

interface AppointmentDetailsDialogProps {
  event: CalendarEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allowCancel: boolean;
  allowReschedule?: boolean;
  rescheduleUrl?: string;
  hideVideoAfterMinutes?: number;
  onRescheduleClick?: (event: CalendarEvent) => void;
}

export const AppointmentDetailsDialog = ({
  event,
  open,
  onOpenChange,
  allowCancel,
  allowReschedule,
  rescheduleUrl,
  hideVideoAfterMinutes,
  onRescheduleClick,
}: AppointmentDetailsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        {event && (
          <AppointmentDetailsContent
            event={event}
            onOpenChange={onOpenChange}
            allowCancel={allowCancel}
            allowReschedule={allowReschedule}
            rescheduleUrl={rescheduleUrl}
            hideVideoAfterMinutes={hideVideoAfterMinutes}
            onRescheduleClick={onRescheduleClick}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
